<div class="drawer-detail-container">
  <!-- ════ HEADER BAR ════ -->
  <div class="drawer-header">
    <div class="header-info">
      <h2 class="drawer-title">{{ campanhaData?.titulo || 'Detalhes da Campanha' }}</h2>
      <div class="header-badges">
        <span class="badge-tag" *ngIf="campanhaData?.categoria?.descricao">
          <i class="fas fa-tag"></i> {{ campanhaData?.categoria?.descricao }}
        </span>
        <span class="badge-location" *ngIf="campanhaData?.provincia?.descricao">
          <i class="fas fa-map-marker-alt"></i> {{ campanhaData?.provincia?.descricao }}
        </span>
        <span class="badge-status" [attr.data-status]="campanhaData?.estado">
          {{ campanhaData?.estado || 'Pendente' }}
        </span>
      </div>
    </div>

    <div class="drawer-header-actions">
      <button *ngIf="showExtend" type="button" class="btn-action-icon" title="Ver em ecrã completo"
        (click)="expandDetalhe()">
        <i class="fas fa-up-right-and-down-left-from-center"></i>
      </button>
      <button type="button" class="btn-action-icon btn-close" title="Fechar" (click)="closeDetalhe()">
        <i class="fas fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- ════ CONTENT BODY ════ -->
  <div class="drawer-body">
    <!-- Financial Highlight Card -->
    <div class="financial-card">
      <div class="fin-card-header">
        <div class="fin-stat">
          <span class="fin-lbl">Arrecadado</span>
          <strong class="fin-val highlight">{{ (campanhaData?.valorArrecado || 0) | money }} Kz</strong>
        </div>
        <div class="fin-stat text-right">
          <span class="fin-lbl">Meta Global</span>
          <strong class="fin-val">{{ (campanhaData?.metaArrecadar || 0) | money }} Kz</strong>
        </div>
      </div>

      <div class="fin-progress-track">
        <div class="fin-progress-fill" [style.width.%]="
            campanhaData?.metaArrecadar
              ? ((campanhaData?.valorArrecado || 0) / campanhaData?.metaArrecadar) * 100 > 100
                ? 100
                : ((campanhaData?.valorArrecado || 0) / campanhaData?.metaArrecadar) * 100
              : 0
          "></div>
      </div>

      <div class="fin-stats-row">
        <div class="mini-stat">
          <i class="fas fa-users text-blue-500"></i>
          <div>
            <strong>{{ campanhaData?.totalApoiantes || 0 }}</strong>
            <span>Doadores</span>
          </div>
        </div>
        <div class="mini-stat">
          <i class="fas fa-heart text-red-500"></i>
          <div>
            <strong>{{ campanhaData?.curtidas?.totalCurtidas || 0 }}</strong>
            <span>Apoios / Likes</span>
          </div>
        </div>
        <div class="mini-stat">
          <i class="fas fa-comments text-amber-500"></i>
          <div>
            <strong>{{ campanhaData?.totalComentarios || 0 }}</strong>
            <span>Comentários</span>
          </div>
        </div>
        <div class="mini-stat">
          <i class="fas fa-hand-holding-dollar text-green-600"></i>
          <div>
            <strong>{{ campanhaData?.tipoFinanciamento || 'Doação' }}</strong>
            <span>Modalidade</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Description Block -->
    <div class="section-card">
      <h3 class="section-heading">
        <i class="fas fa-align-left text-primary"></i>
        <span>Descrição Curta</span>
      </h3>
      <p class="description-text">
        <app-truncate-text [text]="campanhaData?.descricaoCurta || 'Sem descrição informada.'"
          [limit]="180"></app-truncate-text>
      </p>
    </div>

    <!-- Timeline & Dates -->
    <div class="section-card">
      <h3 class="section-heading">
        <i class="fas fa-calendar-days text-primary"></i>
        <span>Cronograma da Campanha</span>
      </h3>
      <div class="info-grid-3">
        <div class="info-item">
          <span class="info-lbl">Data de Criação</span>
          <strong class="info-val">{{ campanhaData?.dataCriacaoFormatada || '—' }}</strong>
        </div>
        <div class="info-item">
          <span class="info-lbl">Data de Início/Aprovação</span>
          <strong class="info-val">{{ campanhaData?.dataInicioFormatada || '—' }}</strong>
        </div>
        <div class="info-item">
          <span class="info-lbl">Término Previsto</span>
          <strong class="info-val">{{ campanhaData?.dataTerminoFormatada || '—' }}</strong>
        </div>
      </div>
    </div>

    <!-- Creator & Bank Information -->
    <div class="section-card">
      <h3 class="section-heading">
        <i class="fas fa-user-shield text-primary"></i>
        <span>Dados do Promotor / Beneficiário</span>
      </h3>
      <div class="info-grid-2">
        <div class="info-item">
          <span class="info-lbl">Nome do Criador</span>
          <strong class="info-val">{{ campanhaData?.utilizadorNome || 'Não informado' }}</strong>
        </div>
        <div class="info-item">
          <span class="info-lbl">Telefone</span>
          <strong class="info-val">{{ campanhaData?.utilizadorTelefone || 'Não informado' }}</strong>
        </div>
        <div class="info-item">
          <span class="info-lbl">Email</span>
          <strong class="info-val">{{ campanhaData?.utilizadorEmail || 'Não informado' }}</strong>
        </div>
        <div class="info-item">
          <span class="info-lbl">IBAN para Repasse</span>
          <strong class="info-val mono">{{ campanhaData?.utilizadorIban || 'Não informado' }}</strong>
        </div>
      </div>

      <!-- Commission notice if closed -->
      <div class="commission-notice mt-3" *ngIf="campanhaData?.estadoCampanhaENUM === 6">
        <i class="fas fa-percent text-primary"></i>
        <div>
          <span class="com-lbl">Taxa de Comissão FundCube ({{ ComissaoCampanha }}%):</span>
          <strong class="com-val">Kz {{ getComissao(campanhaData?.valorArrecado) | money }}</strong>
        </div>
      </div>
    </div>

    <!-- Recompensas da Campanha (quando for modalidade Recompensa) -->
    <div class="section-card" *ngIf="isCampanhaRecompensa() && campanhaData?.recompensa?.length">
      <div class="section-header-row">
        <h3 class="section-heading mb-0">
          <i class="fas fa-gift text-primary"></i>
          <span>Recompensas Registadas ({{ campanhaData?.recompensa?.length || 0 }})</span>
        </h3>
        <span class="badge-total-rewards">
          <i class="fas fa-coins mr-1"></i> Total: <strong>{{ getSomaRecompensas() | money }} Kz</strong>
        </span>
      </div>

      <div class="admin-rewards-list mt-3">
        <div class="admin-reward-card" *ngFor="let rec of campanhaData.recompensa; let i = index">
          <div class="arc-header">
            <div class="arc-left">
              <span class="arc-num">#{{ i + 1 }}</span>
              <h5 class="arc-title">{{ rec.titulo }}</h5>
            </div>
            <div class="arc-right">
              <span class="arc-type" *ngIf="rec.tipoRecompensa">{{ rec.tipoRecompensa }}</span>
              <strong class="arc-val">{{ rec.valor | money }} Kz</strong>
            </div>
          </div>

          <p class="arc-desc">{{ rec.descricao }}</p>

          <div class="arc-footer">
            <div class="arc-stat">
              <i class="fas fa-boxes-stacked"></i>
              <span>Quantidade: <strong>{{ rec.quantidade }}</strong> (Disponíveis: {{ rec.quantidadeDisponivel ?? rec.quantidade }})</span>
            </div>
            <div class="arc-stat" *ngIf="rec.dataIncioRecompensa || rec.dataInicioRecompensa">
              <i class="fas fa-calendar-alt"></i>
              <span>Vigência: {{ (rec.dataIncioRecompensaFormatada || rec.dataIncioRecompensa || rec.dataInicioRecompensa) | date: 'dd/MM/yyyy' }} até {{ (rec.dataTerminoRecompensaFormatada || rec.dataTerminoRecompensa) | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Attachments & Media -->
    <div class="section-card">
      <h3 class="section-heading">
        <i class="fas fa-paperclip text-primary"></i>
        <span>Anexos e Conteúdo Multimídia</span>
      </h3>

      <div class="attachments-row">
        <!-- PDF Document -->
        <div class="file-card" *ngIf="docPreview && docInfo" (click)="abrirDoc()" role="button" tabindex="0"
          (keydown.enter)="abrirDoc()">
          <div class="file-icon pdf">
            <i class="fas fa-file-pdf"></i>
          </div>
          <div class="file-info">
            <h5 class="file-name">{{ docInfo.nome }}</h5>
            <span class="file-meta">{{ docInfo.tamanho }} · Documento</span>
          </div>
          <span class="file-action"><i class="fas fa-arrow-up-right-from-square"></i></span>
        </div>

        <!-- Cover Image -->
        <div class="file-card" *ngIf="imgPreview && imgInfo" (click)="abrirImagem()" role="button" tabindex="0"
          (keydown.enter)="abrirImagem()">
          <div class="file-icon image">
            <i class="fas fa-file-image"></i>
          </div>
          <div class="file-info">
            <h5 class="file-name">{{ imgInfo.nome }}</h5>
            <span class="file-meta">{{ imgInfo.tamanho }} · Imagem</span>
          </div>
          <span class="file-action"><i class="fas fa-eye"></i></span>
        </div>

        <!-- Video file or link -->
        <div class="file-card" *ngIf="linkVideo" (click)="abrirVideoLink(linkVideo)" role="button" tabindex="0"
          (keydown.enter)="abrirVideoLink(linkVideo)">
          <div class="file-icon video">
            <i class="fab fa-youtube"></i>
          </div>
          <div class="file-info">
            <h5 class="file-name">Vídeo do YouTube</h5>
            <span class="file-meta">Visualizar no Player</span>
          </div>
          <button type="button" class="file-action-btn" (click)="abrirLinkExterno(linkVideo, $event)"
            title="Abrir link no YouTube">
            <i class="fas fa-external-link-alt"></i>
          </button>
        </div>

        <div class="file-card" *ngIf="!linkVideo && VidInfo" (click)="abrirVideo()" role="button" tabindex="0"
          (keydown.enter)="abrirVideo()">
          <div class="file-icon video">
            <i class="fas fa-file-video"></i>
          </div>
          <div class="file-info">
            <h5 class="file-name">{{ VidInfo.nome }}</h5>
            <span class="file-meta">{{ VidInfo.tamanho }} · MP4</span>
          </div>
          <span class="file-action"><i class="fas fa-play"></i></span>
        </div>
      </div>
    </div>

    <!-- Social Networks -->
    <div class="section-card" *ngIf="campanhaData?.redesSociaisList?.length">
      <h3 class="section-heading">
        <i class="fas fa-share-nodes text-primary"></i>
        <span>Redes Sociais do Projecto</span>
      </h3>
      <div class="social-links-grid">
        <a *ngFor="let url of campanhaData?.redesSociaisList" [href]="url" target="_blank" rel="noopener"
          class="social-pill">
          <i [class]="url | socialIcon"></i>
          <span>{{ url | trimText: 30 }}</span>
          <i class="fas fa-arrow-up-right-from-square text-xs ml-auto"></i>
        </a>
      </div>
    </div>

    <!-- Donations & Backers Table -->
    <div class="section-card">
      <div class="section-header-row">
        <h3 class="section-heading mb-0">
          <i class="fas fa-hand-holding-heart text-primary"></i>
          <span>Apoios e Doações</span>
        </h3>
        <span class="badge-counter" *ngIf="pagination.totalRecords !== undefined">
          {{ pagination.totalRecords }} registos
        </span>
      </div>

      <div class="table-wrapper mt-3">
        <ng-container *ngIf="pagamentos?.length; else noPayments">
          <p-table [value]="pagamentos" stripedRows [tableStyle]="{ 'min-width': '100%' }" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Doador</th>
                <th>Data</th>
                <th>Valor Doado</th>
                <th>Taxa ({{ taxaServico || 0 }}%)</th>
                <th>Estado</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-payment>
              <tr>
                <td>
                  <div class="donor-cell">
                    <div class="donor-avatar">
                      {{ (payment?.utilizadorNome ? payment?.utilizadorNome[0] : 'D') | uppercase }}
                    </div>
                    <span class="donor-name">{{ payment?.utilizadorNome || 'Anónimo' }}</span>
                  </div>
                </td>
                <td class="text-sm text-secondary">
                  {{ payment?.dataCriacaoFormatada }}
                </td>
                <td class="font-semibold text-primary">
                  {{ (payment?.valorDoadoTotal ?? payment?.valorApoio) | money }} Kz
                </td>
                <td class="text-sm">
                  {{
                  (payment?.valorTaxa != null
                  ? payment?.valorTaxa
                  : ((getValorOriginal(payment?.valorApoio, payment?.taxaServico ?? taxaServico) *
                  (payment?.taxaServico ?? taxaServico)) /
                  100)
                  ) | money
                  }} Kz
                </td>
                <td>
                  <span class="payment-status-badge" [attr.data-status]="payment?.estadoApoio">
                    {{ payment?.estadoApoio }}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="pagination-container mt-3">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPagePayment($event)">
            </app-paginator-control>
          </div>
        </ng-container>

        <ng-template #noPayments>
          <div class="nodata-inner">
            <app-data-void titulo="Sem pagamentos nesta campanha"
              descricao="Ainda não foram registadas contribuições para este projecto."></app-data-void>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Vídeo -->
<p-dialog header="Vídeo da Campanha" [(visible)]="showVideo" [modal]="true"
  [style]="{ width: '90vw', maxWidth: '850px' }" [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container" *ngIf="showVideo">
    <div class="modal-viewer-toolbar" *ngIf="linkVideo">
      <span class="doc-title"><i class="fab fa-youtube text-red-600 mr-2"></i>Vídeo Oficial da Campanha</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar" (click)="abrirLinkExterno(linkVideo, $event)">
          <i class="fas fa-external-link-alt"></i> Abrir no YouTube
        </button>
      </div>
    </div>
    <div class="video-embed-wrap" *ngIf="embedVideoUrl">
      <iframe [src]="embedVideoUrl" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
        class="w-full aspect-video block"></iframe>
    </div>
    <video *ngIf="!embedVideoUrl && vidPreview" [src]="vidPreview" controls width="100%" class="rounded-b-lg"></video>
  </div>
</p-dialog>

<!-- Modal de Imagem -->
<p-dialog header="Capa da Campanha" [(visible)]="showImage" [modal]="true"
  [style]="{ width: '85vw', maxWidth: '800px' }" [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container" *ngIf="imgPreview">
    <div class="modal-viewer-toolbar">
      <span class="doc-title">{{ imgInfo?.nome || 'Imagem da Campanha' }}</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar"
          (click)="descarregarFicheiro(imgRawUrl, imgInfo?.nome || 'imagem.jpg', $event)">
          <i class="fas fa-download"></i> Descarregar
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(imgRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Nova Aba
        </button>
      </div>
    </div>
    <div class="modal-img-wrap">
      <img [src]="imgPreview" alt="Capa da Campanha"
        class="max-h-[75vh] w-auto max-w-full rounded-b-lg object-contain mx-auto block" />
    </div>
  </div>
</p-dialog>

<!-- Modal de Documento -->
<p-dialog header="Documento da Campanha" [(visible)]="ShowDoc" [modal]="true"
  [style]="{ width: '85vw', maxWidth: '1200px', height: '90vh' }"
  [contentStyle]="{ height: 'calc(90vh - 65px)', padding: '0', overflow: 'hidden' }" (onHide)="closeDoc()">
  <div class="modal-viewer-container h-full flex flex-col" *ngIf="docPreview">
    <div class="modal-viewer-toolbar flex-shrink-0">
      <span class="doc-title">{{ docInfo?.nome || 'Apresentação da Campanha' }}</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar"
          (click)="descarregarFicheiro(docRawUrl, docInfo?.nome || 'documento.pdf', $event)">
          <i class="fas fa-download"></i> Descarregar PDF
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(docRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Abrir em Nova Aba
        </button>
      </div>
    </div>
    <div class="modal-iframe-viewer flex-1 w-full h-full">
      <iframe [src]="docPreview" width="100%" height="100%" class="border-0 w-full h-full block"></iframe>
    </div>
  </div>
</p-dialog>